import React, { useState } from "react";
import {
    Form,
    Input,
    Button,
    Typography,
    Row,
    Col,
    message,
    Spin
} from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { useHistory, useLocation } from "react-router-dom";
import LeftLayout from "../pageHeader/LeftLayout";
import { routes } from "../../routes/Routes";
import _BankerService from "../../modules/BankerService";
import { COMMON_ERROR_MSG } from "../../constants/constants";
import {
    COMPLIANCE_ADMINISTRATOR_ROLE,
    LOAN_OFFICER_ROLE_ID,
    SENIOR_PRIVATE_BANKER_ROLE_ID,
    UNDERWRITER_BANKER_ROLE_ID,
    PRIVATE_WEALTH_ADVISOR_ROLE_ID,
    COMPLIANCE_ADMIN_ROLE_ID,
} from "../../constants/DataConstants";

import HeaderComponentWithTitleAndLogo from "../../components/HeaderComponentWithTitleAndLogo/HeaderComponentWithTitleAndLogo";
import MainLayout from "../../components/MainLayout/MainLayout";
import CreatePassword from "../../components/Password/CreatePassword";

const { Title, Text } = Typography;

const CreateNewPasswordForBanker = () => {
    const history = useHistory();
    const location = useLocation();
    let data = location.state;
    let emailId = "";
    if (data && data.email) {
        emailId = data.email;
    }

    const [email] = useState(emailId);

    const [loading, setLoading] = useState(false);
    const BankerId = localStorage.getItem("BankerId");
    const onFinish = async (values) => {
        setLoading(true);
        try {
            const reqObj = {
                Id: BankerId,
                ScreenName: "confirmpassword",
                Password: values.newPassword,
                ConfirmPassword: values.confirmPassword,
            }
            const res = await _BankerService.updateBankerData(reqObj);
            if (res.data.IsSuccess) {
                setLoading(false);
                message.success(res.data.Message)

                // Banker-role onboarding now redirects straight to the role dashboard from here,
                // skipping Personal/Professional Details (those screens/routes are unchanged and
                // still reachable from the Banker Profile page's edit icons). Same role->dashboard
                // logic as ProfessionalDetails.js's onFinish, just triggered a step earlier.
                let resObj = res.data.Obj;
                localStorage.setItem("listUserRoles", JSON.stringify(resObj?.listUserRoles));
                localStorage.setItem("Password", resObj?.Ps);

                if (res.data.Obj.RoleId === LOAN_OFFICER_ROLE_ID) {
                    localStorage.setItem("LoanOfficerId", res.data.Obj.BankerId);
                    localStorage.setItem("RoleId", res.data.Obj.RoleId);
                    localStorage.setItem("Role", res.data.Obj.Role);
                    localStorage.setItem("userRole", "LoanOfficer");
                    localStorage.setItem("IsLoanofficerFlag", JSON.stringify(true));
                    localStorage.setItem("IsBankAdminFlag", JSON.stringify(false));
                    localStorage.setItem("IsFirmAdminFlag", JSON.stringify(false));
                    history.push(routes.loanOfficerDashboard.path);
                } else if (res.data.Obj.RoleId === COMPLIANCE_ADMIN_ROLE_ID) {
                    localStorage.setItem("BankerId", res.data.Obj.BankerId);
                    localStorage.setItem("RoleId", res.data.Obj.RoleId);
                    localStorage.setItem("Role", res.data.Obj.Role);
                    localStorage.setItem("userRole", COMPLIANCE_ADMINISTRATOR_ROLE);
                    localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                    localStorage.setItem("IsBankAdminFlag", JSON.stringify(false));
                    localStorage.setItem("IsFirmAdminFlag", JSON.stringify(false));
                    history.push(routes.complianceadmindashboard.path);
                } else if (
                    res.data.Obj.RoleId === SENIOR_PRIVATE_BANKER_ROLE_ID ||
                    res.data.Obj.RoleId === UNDERWRITER_BANKER_ROLE_ID ||
                    res.data.Obj.RoleId === PRIVATE_WEALTH_ADVISOR_ROLE_ID
                ) {
                    localStorage.setItem("RoleId", res.data.Obj.RoleId);
                    localStorage.setItem("Role", res.data.Obj.Role);
                    localStorage.setItem("userRole", res.data.Obj.Role);
                    localStorage.setItem("BankerId", res.data.Obj.BankerId);
                    localStorage.setItem("IsLoanofficerFlag", JSON.stringify(false));
                    localStorage.setItem("IsBankAdminFlag", JSON.stringify(false));
                    localStorage.setItem("IsFirmAdminFlag", JSON.stringify(false));
                    history.push(routes.bankerdashboard.path);
                } else {
                    localStorage.setItem("RoleId", res.data.Obj.RoleId);
                    localStorage.setItem("Role", res.data.Obj.Role);
                    localStorage.setItem("BankerId", res.data.Obj.BankerId);
                    history.push(routes.bankerdashboard.path);
                }
            } else {
                setLoading(false);
                message.error(res.data.Message || COMMON_ERROR_MSG);
            }
        } catch (err) {
            setLoading(false);
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const validatePassword = (_, value) => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[#@%&!^*.,_+=?]).{8,20}$/;
        if (!value || passwordRegex.test(value)) {
            return Promise.resolve();
        }
        return Promise.reject(
            new Error(
                "Password must include uppercase, lowercase, number, special character and be 8-20 characters long"
            )
        );
    };

    const onBack = () => {
        history.push({ pathname: routes.verifyEmailOtp.path, state: email });
    }

    return (
        <Spin spinning={loading}>

            <MainLayout>
                <HeaderComponentWithTitleAndLogo
                    logoSrc="/websiteLogo.png"
                    logoAlt="Leveridge Logo"
                    title="Create New Password"
                    subtitle="Set a secure password for your account"
                />
                <CreatePassword
                    onFinish={onFinish}
                    validatePassword={validatePassword}
                    loading={loading}
                    onBack={onBack}
                />
            </MainLayout>
            {/* <LeftLayout>
                <div className="subBackgroundLayout mt40">
                    <Title level={3} style={{ fontWeight: "bold", color: "#d3d3d3", marginBottom: 60 }}>
                        Banker's Portal
                    </Title>

                    <Title level={4} style={{ marginBottom: 24 }}>
                        Create New Password
                    </Title>

                    <Form layout="vertical" onFinish={onFinish} requiredMark={true}>
                        <Form.Item
                            label="New Password"
                            name="newPassword"
                            rules={[
                                { required: true, message: "New Password is required" },
                                { validator: validatePassword }
                            ]}

                        >
                            <Input.Password maxLength={20} placeholder="Enter New Password" />
                        </Form.Item>

                        <Form.Item
                            label="Confirm Password"
                            name="confirmPassword"
                            dependencies={["newPassword"]}

                            rules={[
                                { required: true, message: "Confirm Password is required" },
                                ({ getFieldValue }) => ({
                                    validator(_, value) {
                                        if (!value || getFieldValue("newPassword") === value) {
                                            return Promise.resolve();
                                        }
                                        return Promise.reject(new Error("Passwords do not match"));
                                    }
                                })
                            ]}
                        >
                            <Input.Password maxLength={20} placeholder="Enter Confirm Password"  />
                        </Form.Item>

                        <Text type="secondary" style={{ fontSize: 13 }}>
                            A password must contain at least 1 capital letter, 1 small letter, 1 number, 1 special character (#,@,%,!,&amp;,\*,\_,+,?, etc). Minimum 8 characters and maximum 20 characters.
                        </Text>
                        <Form.Item>
                            <div style={{ display: "flex", justifyContent: "flex-end", gap: 16, marginTop: 30 }}>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    className="w100"
                                >
                                    Save And Proceed <RightOutlined />
                                </Button>
                            </div>
                        </Form.Item>
                    </Form>
                </div>
            </LeftLayout> */}
        </Spin>
    );
};

export default CreateNewPasswordForBanker;
